import { ApplicationState } from "..";
import { CostRateTable } from "../CostRateTableStore";

export type IWithDefaultCostRateTable = {
    defaultCostRateTableId?: string;
    defaultCostRateTable?: CostRateTable;
};

export const getDefaultCostRateTable = (state: ApplicationState): CostRateTable | undefined => {
    const ids = state.costRateTables.allIds;
    const byId = state.costRateTables.byId;

    if (ids.length === 1) {
        return byId[ids[0]];
    }

    for (const id of ids) {
        const t = byId[id];
        if (t?.isDefault) {
            return t;
        }
    }

    return ids.length > 0 ? byId[ids[0]] : undefined;
};
